<div class="home-container">
  <div class="hero-section">
    <h1>Firefly Services Sandbox</h1>
  </div>

  <div class="features-grid">
    <div class="feature-card">
      <h3>企画・設計</h3>
      <p>ストーリーボード作成、3Dモデリング</p>
      <div class="feature-links">
        <a routerLink="/storyboard" class="feature-link">ラフデザイン作成</a>
        <a routerLink="/storyboard3d" class="feature-link">3Dから絵コンテ</a>
      </div>
    </div>

    <div class="feature-card">
      <h3>動画生成・編集</h3>
      <p>ビジュアルナラティブ制作、画像バリエーション生成、カスタムモデル画像生成</p>
      <div class="feature-links">
        <a routerLink="/visual-narrative-maker" class="feature-link">Visual Narrative Maker</a>
        <a routerLink="/key-visual-splitter" class="feature-link">Key Frame Generator</a>
        <a routerLink="/custom-model-generator" class="feature-link">Custom Model Image Generator</a>
      </div>
    </div>

  </div>
</div>
